import React, { useState } from 'react';

export default function FeedbackForm() {
  const [feedback, setFeedback] = useState({
    usefulness: '',
    improvement: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({
    usefulness: false,
    improvement: false
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFeedback({ ...feedback, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;
    const { usefulness, improvement } = feedback;

    // Reset errors
    setErrors({
      usefulness: false,
      improvement: false
    });

    // Error checking for usefulness rating (must be between 1 and 10)
    if (!usefulness || usefulness < 1 || usefulness > 10) {
      hasError = true;
      document.getElementById("usefulness").classList.add("lite-invalid-input");
      setErrors((prev) => ({ ...prev, usefulness: true }));
    } else {
      document.getElementById("usefulness").classList.remove("lite-invalid-input");
    }

    // Error checking for the feedback text
    if (!improvement || improvement.trim() === '') {
      hasError = true;
      document.getElementById("improvement").classList.add("lite-invalid-input");
      setErrors((prev) => ({ ...prev, improvement: true }));
    } else {
      document.getElementById("improvement").classList.remove("lite-invalid-input");
    }

    if (!hasError) {
      try {
        // Send POST request to /datapulse/feedback
        const success = await submitFeedback(feedback);
        if (success) {
          setSubmitted(true);
        }
      } catch (error) {
        console.error("Error submitting feedback:", error);
      }
    }
  };

  const submitFeedback = async (feedbackData) => {
    const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch('/datapulse/feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': authenticityToken,
        },
        body: JSON.stringify({ feedback: feedbackData })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          console.log('Feedback submitted successfully', data);
          return true;
        } else {
          console.error('Failed to submit feedback', data.error_message);
          return false;
        }
      } else {
        console.error('Failed to submit feedback');
        return false;
      }
    } catch (error) {
      console.error('Request error:', error);
      return false;
    }
  };

  return (
    <div className="feedback-form">
      <h4>Submit Feedback for DataPulse</h4>
      {!submitted ? (
        <form onSubmit={handleSubmit}>
          <div className="lite-form-group mb-3">
            <label className="input-label" htmlFor="usefulness">
              On a scale of 1-10, how useful is DataPulse to you?
            </label>
            <input
              className={`lite-input ${errors.usefulness ? 'lite-invalid-input' : ''}`}
              type="number"
              id="usefulness"
              name="usefulness"
              value={feedback.usefulness}
              onChange={handleInputChange}
            />
          </div>

          <div className="lite-form-group mb-3">
            <label className="input-label" htmlFor="improvement">
              What can we do to improve DataPulse?
            </label>
            <textarea
              className={`lite-input ${errors.improvement ? 'lite-invalid-input' : ''}`}
              id="improvement"
              name="improvement"
              value={feedback.improvement}
              onChange={handleInputChange}
              rows="4"
              cols="50"
              placeholder="Enter your feedback here"
            />
          </div>

          <div className="d-flex justify-content-end">
            <button
              type="submit"
              className="button b-type-primary b-size-normal b-color-green"
              style={{ marginTop: '20px' }}
            >
              Submit Feedback
            </button>
          </div>
        </form>
      ) : (
        <>
          <p className="mt-4">Thank you for your feedback! We sincerely appreciate it as we seek to make the platform better.</p>
          <p className="mt-3">If you still need support reach out to us at datapulse@digitalposition.com</p>
        </>
      )}
    </div>
  );
}
